export default {
    signIn_Register: "Sign in using {v1}",
    signIn_email_hint: "Email address",
    signIn_password_hint: "Password",
    signIn_enter_using_email: "or enter using your email",
    signIn_signInBtn: "Sign In",
    signIn_signIn_title: "Sign In",
    signIn_signUp_title: "Register",
    signIn_RegisterWithEmail: "Register with email address",
    signIn_firstName_hint: "First name",
    signIn_lastName_hint: "Last name",
    signIn_agreeTo: "I agree to AirVote",
    signIn_tAndC: "Terms and Conditions",
    signIn_signUp_btn: "Register",
    password_validation_min_length: "Min 6 chars length",
    password_validation_uppercase: "One uppercase letter",
    password_validation_lowercase: "One lowercase letter",
    profilePosition: "Manage",
    ambassadorBtn_title: 'Become a J-Bar Ambassador',
    ambassadorBtn_subtitle: "Reviews = Rewards",
    ambassadorPopup_title: 'To become a J-Bar Ambassador you need:',
    ambassadorPopup_votes: '20 AirVotes',
    ambassadorPopup_review: 'A Google or FB review',
    giveawayPopup_entered: 'You will be entered into',
    ambassadorPopup_BtnLogin: 'Start by logging in',
    giveawayPopup_BtnReview: 'Leave a review',
    ambassadorPopup_cancel: 'No thanks',
    ambassadorFinishTitle: "J Bar Ambassador Benefits",
    ambassadorMonthlyDrawing: "Every AirVote enters you into a monthly $100 drawing",
    ambassadorReceive: "Ambassadors will receive extra goodies and recognition!",
    ambassadorHelpUsTogether: "Help us succeed together!",
    giveawayPopup_finalStep: 'We appreciate your honest review!\n\nYou have been added to our giveaway drawing.\n\nCome back and vote again: every vote will increase your chances!',
    giveawayPopup_proceedReview: "Proceed to submit a review",
    Thank_for_vote: "Thank you for your vote. Want to track your votes? Sign in using",
    thankVoteTitle1: "Feedback saved",
    thankVoteTitle2_1: "Thanks for voting",
    thankVoteTitle2_2: "Join AirVote so you can review and change your votes",
    reviewSocial: "About us",
    reviewSocialOr: "More about us",
    anonComment: "Add anonymous comment",
    writeFeedBack: "Add a comment",
    voteSuccessText_1: "Vote submitted, thanks!",
    voteSuccessText_2: "Want to change it? Just tap another smiley.",
    voteSuccessText_3: "Have something to say? Leave an optional note",
    feedbackTitle: "Add a note",
    feedbackTitleSoSo: "What could be better?",
    feedbackTitleSad: "What’s not right?",
    feedbackTitleDumpsters: "Additional comments?",
    yourNote: "Your note",
    addYourNote: "Add a note?",
    commentPopupEmail: "Enter your email or phone",
    feedbackText: "I want to hear back on this",
    feedbackTextServiceLog: "Service contact information",
    feedbackTextOr: "or",
    feedbackTextRating: 'Why did you give this speaker this rating?',
    writeAReview: "Write a review",
    writeAReviewTitle: "You can write a review for {v1} here:",
    Logout: "Logout",
    Sync_status: "Sync status",
    Close: "Close",
    title_404: "Page you are trying to reach\nis not available",
    btn_404: "Go back",
    Submit: "Send your comment",
    Cancel: "Cancel",
    powered_by: "Powered by AirVote\nGet it for your business",
    UploadNewPhoto: "Upload new photo",
    RemovePhoto: "Remove photo",
    WrongFormat: "Wrong format. Please use PNG or JPG",
    PhotoOverweight: "Photo is more than {v1}Mb",
    max_attach_photos_count_error: "Only up to {v1} files allowed",
    welcomeAmbassador: "Welcome back, J Bar Ambassador!",
    ambassadorDescription: "Every AirVote enters you into a monthly $100 drawing (limit 1 per location per day)\n" +
        "Ambassadors will receive extra goodies and recognition!\n" +
        "\n" + "Help us succeed together!",
    OK: "OK",
    Placement: "Placement",
    Update: "Save",
    NewPlacementSaved: "New placement was saved",
    PleaseEnterCorrectPlacement: "Please enter correct placement",
    manageGPSAllowTitle: "Mind sharing your location?",
    manageGPSAllowText: "Knowing the exact location of a problem helps us fix it quicker. We will not track your location or share it with anyone outside our service team",
    manageGPSAllowOKButton: "OK to share",
    manageGPSAllowCancelButton: "Prefer not to",
    level2_notp: "No TP",
    level2_full: "Full",
    level2_dirty: "Dirty",
    level2_smells: "Smells",
    level2_broken: "Something broken",
    level2_otherl: "Other",
    level2_nopaper: "No paper towels",
    level2_title: "Services Performed",
    level2_maxCount: "Maximum number of items to choose: {v1}",
    need_audio_permission_error: "Please give us access to your microphone to record audio",
    play_dino: "Play DINO",
    dino_play_btn: "Play",
    dino_jump_btn: "Jump",
    dino_down_btn: "Down",
    vote_screen_public_review_popup_title: "We appreciate your public review:",
    QR_smiley_disabled: "This QR Smiley® has been disabled.\nPlease take your feedback directly to the business.",
    QR_smiley_disabled_links: "Any questions about AirVote®?\nCheck out {v1} or email us at {v2}.",
    QR_smiley_disabled_footer: "Thank you for providing your feedback!",
    sl_final_Title1: "Service log saved!",
    serviceLogNoAccess: "You don't have access to this service log panel.\nPlease contact your management for correct access rights.",
    serviceLogNoAccessLinks: "Or contact AirVote using email {v1}.",
    serviceLogNoAccessFooter: "Thank you for using AirVote",
    serviceLogInfoBtn: "Service history",
    noServiceLogs: "No service logs found",
    snapPicturePopupTitle: "Confirm your vote with the restroom picture",
    snapPictureButton: "Snap a picture",
    snapPicturePopupContinue: "Continue",
    subtitleDefault: "Your picture of the problem is appreciated!",
    signIn_Pin: "Sign in with PIN",
}
